import { render } from "./DeleteEventModal.vue?vue&type=template&id=5325b1d1"
import script from "./DeleteEventModal.vue?vue&type=script&lang=js"
export * from "./DeleteEventModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__